import React from 'react';
import colors from '../../../scss/colors';

function DownloadIcon({ width, height, color }) {
  return (
    <svg width={width} height={height} viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        // eslint-disable-next-line max-len
        d="M27.5 13.9033C31.1975 13.9237 33.2001 14.0886 34.5057 15.3942C36 16.8885 36 19.2923 36 24.0999V25.7999C36 30.6092 36 33.013 34.5057 34.5073C33.0131 35.9999 30.6076 35.9999 25.8 35.9999H12.2C7.3924 35.9999 4.9869 35.9999 3.4943 34.5073C2 33.0113 2 30.6092 2 25.7999V24.0999C2 19.2923 2 16.8885 3.4943 15.3942C4.7999 14.0886 6.8025 13.9237 10.5 13.9033"
        stroke={color || colors.LIGHT_GREY}
        strokeWidth="3.5"
        strokeLinecap="round"
      />
      <path
        d="M18.9984 2V24.1M18.9984 24.1L13.8984 18.15M18.9984 24.1L24.0984 18.15"
        stroke={color || colors.LIGHT_GREY}
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default DownloadIcon;
